import { useEffect, useState } from 'react';

const useModal = () => {

	const [visible, setVisible] = useState(false)

	useEffect(() => {
		if (visible) {
			return document.getElementsByTagName('body')[0].style.overflow = 'hidden';
		}
		document.getElementsByTagName('body')[0].style.overflow = null

		return () => {
			document.getElementsByTagName('body')[0].style.overflow = null
		}
	}, [visible])

	function show() {
		setVisible(true)
	}

	function hide() {
		setVisible(false)
	}

	return {
		hide,
		show,
		visible,
	}
};

export default useModal;
